import { defineComponent as F, ref as z, computed as d, inject as M, useSlots as ee, createElementBlock as s, openBlock as o, normalizeStyle as c, normalizeClass as v, createCommentVNode as I, renderSlot as C, createElementVNode as k, createBlock as r, resolveDynamicComponent as g, toDisplayString as u, createVNode as V, unref as l, withCtx as b, Fragment as y, createTextVNode as T, withModifiers as P, createSlots as oe, nextTick as E } from "vue";
import ne from "./highrise381.mjs";
import D from "./highrise363.mjs";
import se from "./highrise484.mjs";
import te from "./highrise485.mjs";
import ie from "./highrise366.mjs";
import { JSONtoNaiveVars as m } from "./highrise343.mjs";
import "./highrise64.mjs";
import { createInputSizeStyle as le, inputTextAlignStyles as re, IconSizeStyles as ue, createInlineInputSizeStyle as ae, inlineInputStyles as fe, commonInputStyles as pe, getTooltipStyles as de } from "./highrise479.mjs";
import { inlineThemeOverrides as ce } from "./highrise486.mjs";
import { fallbackSize as ye } from "./highrise252.mjs";
import { COMPONENT_NAME as me } from "./highrise178.mjs";
import he from "./highrise487.mjs";
import ve from "./highrise488.mjs";
import Ie from "./highrise78.mjs";
/* empty css            */
const we = {
  key: 0,
  class: "hr-input__prefix-icon"
}, ke = ["src"], ge = { key: 2 }, be = { class: "hr-input__text-content" }, Se = ["src"], Be = { key: 2 }, Ce = { class: "hr-input__prefix-container" }, Ve = {
  key: 0,
  class: "hr-input__prefix-icon"
}, Te = ["src"], Pe = { key: 2 }, $e = { class: "hr-input__suffix-container" }, ze = ["src"], xe = { key: 2 }, Oe = ["src"], Ne = { key: 2 }, Ae = {
  key: 0,
  class: "hr-input__inline-cta"
}, je = F({
  name: me.INPUT
}), Ze = /* @__PURE__ */ F({
  ...je,
  props: {
    id: {},
    modelValue: { default: "" },
    type: { default: "text" },
    placeholder: {},
    readonly: { type: Boolean, default: !1 },
    rows: { default: 3 },
    maxlength: {},
    minlength: {},
    loading: { type: Boolean, default: void 0 },
    autosize: { type: [Boolean, Object] },
    clearable: { type: Boolean, default: !1 },
    size: {},
    showCount: { type: Boolean },
    disabled: { type: Boolean },
    inputProps: {},
    showPasswordOn: { default: "click" },
    prefixIcon: {},
    suffixIcon: {},
    suffixIconTooltipContent: {},
    inline: { type: Boolean, default: !1 },
    showInlineCTA: { type: Boolean, default: !1 },
    showInlineBottomBorder: { type: Boolean, default: !0 },
    textAlign: { default: "start" },
    autofocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "onBlur", "focus", "change", "blur"],
  setup(R, { expose: U, emit: G }) {
    const J = ["text", "textarea", "password"], h = z(!1), a = z(null), w = z(!1), t = R, S = G, f = d(() => J.includes(t.type) ? t.type : "text"), q = M("hr-form"), H = M("hr-input-group-size"), B = d(() => ye(t.size || H || q || "sm")), p = d(() => {
      const e = le(B.value);
      return {
        ...t.inline ? m(fe) : m(pe()),
        ...t.inline ? m(ae(B.value)) : m(e),
        ...m(ue(B.value)),
        ...m(re(t.textAlign))
      };
    }), K = d(() => ({
      ...t.inputProps,
      style: { textAlign: t.textAlign }
    })), x = d(() => ({ ...m(de()) })), L = d(() => ({
      [`hr-input--${B.value}`]: !0,
      "hr-input--inline": t.inline
    }));
    let O = null;
    const N = ee(), Q = (e) => {
      e.target.closest(".hr-input__password-eye") || (O = t.modelValue, h.value = !0, E(() => {
        var n;
        (n = a.value) == null || n.focus();
      }));
    }, W = (e) => {
      if (t.showInlineCTA) {
        const n = e == null ? void 0 : e.relatedTarget;
        if (n) {
          const i = n.closest('[data-testid="hl-input-confirm"]'), _ = n.closest('[data-testid="hl-input-cancel"]');
          if (i || _)
            return;
          A();
          return;
        }
        e == null || e.preventDefault(), E(() => {
          var i;
          (i = a.value) == null || i.focus();
        });
        return;
      }
      h.value = !1, S("onBlur"), S("blur", e);
    }, A = () => {
      S("update:modelValue", O), h.value = !1;
    }, X = () => {
      h.value = !1, S("onBlur");
    }, Y = () => {
      f.value === "password" && (w.value = !w.value);
    }, Z = () => {
      f.value === "password" && (w.value = !0);
    }, j = () => {
      f.value === "password" && (w.value = !1);
    }, $ = d(() => f.value !== "password" ? !1 : w.value);
    return U({
      focus: () => {
        var e;
        return (e = a.value) == null ? void 0 : e.focus();
      },
      blur: () => {
        var e;
        return (e = a.value) == null ? void 0 : e.blur();
      },
      select: () => {
        var e;
        return (e = a.value) == null ? void 0 : e.select();
      },
      inputRef: a,
      // expose the raw ref if needed
      scrollTo: (e) => {
        var n;
        (n = a.value) == null || n.scrollTo(e);
      }
    }), (e, n) => e.inline && !h.value && !e.readonly ? (o(), s("div", {
      key: 0,
      class: v(["hr-input__inline-text", [
        !h.value && !e.showInlineBottomBorder ? "hr-input__inline-text--no-border" : "hr-input__inline-text--with-border",
        e.disabled ? "disabled" : "",
        e.modelValue ? "has-value" : "",
        { "hr-input__inline-text--password": f.value === "password" && !$.value }
      ]]),
      style: c(p.value),
      onClick: n[4] || (n[4] = (i) => !e.disabled && Q(i))
    }, [
      e.prefixIcon ? (o(), s("div", we, [
        typeof e.prefixIcon == "string" ? (o(), s("img", {
          key: 0,
          src: e.prefixIcon,
          alt: "Prefix Icon"
        }, null, 8, ke)) : typeof e.prefixIcon == "object" || typeof e.prefixIcon == "function" ? (o(), r(g(e.prefixIcon), { key: 1 })) : (o(), s("span", ge, u(e.prefixIcon), 1))
      ])) : I("", !0),
      C(e.$slots, "prefix", {}, void 0, !0),
      k("div", be, [
        V(l(he), {
          style: c(p.value),
          class: v(e.modelValue ? "hr-input__text-content--active" : "")
        }, {
          default: b(() => [
            f.value === "password" && e.modelValue ? (o(), s(y, { key: 0 }, [
              $.value ? (o(), s(y, { key: 0 }, [
                T(u(e.modelValue), 1)
              ], 64)) : (o(), s(y, { key: 1 }, [
                T(u("•".repeat(String(e.modelValue).length)), 1)
              ], 64))
            ], 64)) : (o(), s(y, { key: 1 }, [
              T(u(e.modelValue || e.placeholder), 1)
            ], 64))
          ]),
          _: 1
        }, 8, ["style", "class"])
      ]),
      f.value === "password" && e.modelValue ? (o(), s("div", {
        key: 1,
        class: "hr-input__password-eye",
        onClick: n[0] || (n[0] = P((i) => t.showPasswordOn === "click" && Y(), ["stop"])),
        onMousedown: n[1] || (n[1] = P((i) => t.showPasswordOn === "mousedown" && Z(), ["stop"])),
        onMouseup: n[2] || (n[2] = P((i) => t.showPasswordOn === "mousedown" && j(), ["stop"])),
        onMouseleave: n[3] || (n[3] = P((i) => t.showPasswordOn === "mousedown" && j(), ["stop"]))
      }, [
        $.value ? (o(), r(l(se), { key: 1 })) : (o(), r(l(te), { key: 0 }))
      ], 32)) : I("", !0),
      e.suffixIcon ? (o(), s("div", {
        key: 2,
        class: v(["hr-input__suffix-icon", { "hr-input__suffix-icon--dropdown": e.suffixIcon === "dropdown" }])
      }, [
        e.suffixIcon === "dropdown" ? (o(), r(l(D), { key: 0 })) : (o(), s(y, { key: 1 }, [
          typeof e.suffixIcon == "string" ? (o(), s("img", {
            key: 0,
            src: e.suffixIcon,
            alt: "Suffix Icon"
          }, null, 8, Se)) : typeof e.suffixIcon == "object" || typeof e.suffixIcon == "function" ? (o(), r(g(e.suffixIcon), { key: 1 })) : (o(), s("span", Be, u(e.suffixIcon), 1))
        ], 64))
      ], 2)) : I("", !0),
      C(e.$slots, "suffix", {}, void 0, !0)
    ], 6)) : (o(), s("div", {
      key: 1,
      class: v(t.inline ? "hr-input__inline-edit-container" : "hr-input-container"),
      "data-testid": "hr-input-container",
      style: c(p.value)
    }, [
      V(l(ve), {
        id: e.id,
        ref_key: "inputRef",
        ref: a,
        style: c(p.value),
        clearable: e.clearable,
        disabled: e.disabled,
        loading: e.loading,
        maxlength: e.maxlength,
        minlength: e.minlength,
        placeholder: e.placeholder,
        readonly: e.readonly,
        rows: e.rows,
        "show-count": e.showCount,
        type: f.value,
        "input-props": K.value,
        value: typeof e.modelValue == "number" ? String(e.modelValue) : e.modelValue,
        autosize: e.autosize,
        "show-password-on": e.showPasswordOn,
        class: v(L.value),
        autofocus: e.autofocus,
        "theme-overrides": e.inline ? l(ce) : void 0,
        "data-testid": "hl-input",
        onBlur: W,
        "onUpdate:value": n[5] || (n[5] = (i) => e.$emit("update:modelValue", i)),
        onChange: n[6] || (n[6] = (i) => e.$emit("change", i)),
        onFocus: n[7] || (n[7] = (i) => e.$emit("focus", i))
      }, oe({ _: 2 }, [
        l(N).prefix || e.prefixIcon ? {
          name: "prefix",
          fn: b(() => [
            k("div", Ce, [
              e.prefixIcon ? (o(), s("div", Ve, [
                typeof e.prefixIcon == "string" ? (o(), s("img", {
                  key: 0,
                  src: e.prefixIcon,
                  alt: "Prefix Icon"
                }, null, 8, Te)) : typeof e.prefixIcon == "object" || typeof e.prefixIcon == "function" ? (o(), r(g(e.prefixIcon), { key: 1 })) : (o(), s("span", Pe, u(e.prefixIcon), 1))
              ])) : I("", !0),
              C(e.$slots, "prefix", {}, void 0, !0)
            ])
          ]),
          key: "0"
        } : void 0,
        l(N).suffix || e.suffixIcon ? {
          name: "suffix",
          fn: b(() => [
            k("div", $e, [
              e.suffixIcon ? (o(), s("div", {
                key: 0,
                class: v(["hr-input__suffix-icon", { "hr-input__suffix-icon--dropdown": e.suffixIcon === "dropdown" }]),
                style: c(p.value)
              }, [
                e.suffixIcon === "dropdown" ? (o(), r(l(D), { key: 0 })) : (o(), s(y, { key: 1 }, [
                  e.suffixIconTooltipContent ? (o(), r(l(Ie), {
                    key: 0,
                    "header-class": "hr-input-suffix-tooltip hr-input-suffix-tooltip-header",
                    "content-class": "hr-input-suffix-tooltip hr-input-suffix-tooltip-content",
                    "arrow-class": "hr-input-suffix-tooltip",
                    "content-style": {
                      padding: "var(--n-tooltip-padding)",
                      ...x.value
                    },
                    "header-style": x.value
                  }, {
                    trigger: b(() => [
                      typeof e.suffixIcon == "string" ? (o(), s("img", {
                        key: 0,
                        src: e.suffixIcon,
                        alt: "Suffix Icon"
                      }, null, 8, ze)) : typeof e.suffixIcon == "object" || typeof e.suffixIcon == "function" ? (o(), r(g(e.suffixIcon), { key: 1 })) : (o(), s("span", xe, u(e.suffixIcon), 1))
                    ]),
                    default: b(() => [
                      T(" " + u(e.suffixIconTooltipContent), 1)
                    ]),
                    _: 1
                  }, 8, ["content-style", "header-style"])) : (o(), s(y, { key: 1 }, [
                    typeof e.suffixIcon == "string" ? (o(), s("img", {
                      key: 0,
                      src: e.suffixIcon,
                      alt: "Suffix Icon"
                    }, null, 8, Oe)) : typeof e.suffixIcon == "object" || typeof e.suffixIcon == "function" ? (o(), r(g(e.suffixIcon), { key: 1 })) : (o(), s("span", Ne, u(e.suffixIcon), 1))
                  ], 64))
                ], 64))
              ], 6)) : I("", !0),
              C(e.$slots, "suffix", {}, void 0, !0)
            ])
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["id", "style", "clearable", "disabled", "loading", "maxlength", "minlength", "placeholder", "readonly", "rows", "show-count", "type", "input-props", "value", "autosize", "show-password-on", "class", "autofocus", "theme-overrides"]),
      e.inline && e.showInlineCTA ? (o(), s("div", Ae, [
        k("button", {
          class: "hr-input__confirm-icon",
          style: c(p.value),
          "data-testid": "hl-input-confirm",
          "aria-label": "Confirm",
          onClick: X
        }, [
          V(l(ne))
        ], 4),
        k("button", {
          class: "hr-input__cancel-icon",
          style: c(p.value),
          "data-testid": "hl-input-cancel",
          "aria-label": "Cancel",
          onClick: A
        }, [
          V(l(ie))
        ], 4)
      ])) : I("", !0)
    ], 6));
  }
});
export {
  Ze as default
};
